import { render, staticRenderFns } from "./ViewRequest.vue?vue&type=template&id=51571240&"
import script from "./ViewRequest.ts?vue&type=script&lang=ts&"
export * from "./ViewRequest.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports